import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const toUnit = (c, unit) => (c == null ? "–" : Math.round(unit === "F" ? (c * 9) / 5 + 32 : c));
export const LABEL = { clear: "Clear", "partly-cloudy": "Partly cloudy", cloudy: "Cloudy", rain: "Rain", drizzle: "Drizzle", thunder: "Thunderstorms", snow: "Snow", fog: "Fog" };
export const PRIVACY = "Used only for your weather. Never shared with your family.";
const round = (n) => Math.round(n * 100) / 100;

const keyFor = (session) => `qhh.wxLoc.${session?.type === "kid" ? `kid:${session.kid?.id}` : `user:${session?.user?.id}`}`;

async function placeName(lat, lon) {
  // BigDataCloud's free client-side reverse geocoder (no key; intended for in-browser use with the device's own location).
  try {
    const r = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`);
    const d = await r.json();
    return d.city || d.locality || null;
  } catch { return null; }
}

function position() {
  return new Promise((res, rej) => {
    if (!navigator.geolocation) return rej(new Error("unavailable"));
    navigator.geolocation.getCurrentPosition((p) => res({ lat: round(p.coords.latitude), lon: round(p.coords.longitude) }), rej, { maximumAge: 15 * 60000, timeout: 10000 });
  });
}

// prompt=false: never asks (screensaver); uses the person's saved choice.
export function useWeather(hubId, session, { prompt = true } = {}) {
  const lsKey = keyFor(session);
  const [choice, setChoice] = useState(() => localStorage.getItem(lsKey));
  const [data, setData] = useState(null);
  const load = useCallback(async (c = choice) => {
    let params = {};
    if (c === "granted") {
      try { const p = await position(); params = { ...p, place: (await placeName(p.lat, p.lon)) || "My location" }; } catch { params = {}; }
    }
    try { const { data: d } = await api.get(`/organizations/${hubId}/weather`, { params }); setData(d); } catch { setData({ unavailable: true, message: "Weather unavailable right now" }); }
  }, [hubId, choice]);
  useEffect(() => {
    if (!choice && prompt) return undefined;
    load();
    const id = setInterval(() => load(), 15 * 60000);
    return () => clearInterval(id);
  }, [load, choice, prompt]);
  const decide = (c) => { localStorage.setItem(lsKey, c); setChoice(c); };
  const setUnit = async (unit) => { await api.put("/me/weather-prefs", { unit }); setData((d) => ({ ...d, unit })); };
  return { data, asking: prompt && !choice, allow: () => decide("granted"), deny: () => decide("denied"), setUnit, reload: load };
}
